import React from 'react';
import './Event.css';

import { FaClock, FaMapMarkerAlt } from 'react-icons/fa'; // Importing icons from react-icons
import { Link } from 'react-router-dom'; // Importing Link for navigation

const Event = (props) => {
 
  // Destructuring props to extract event details
  const { id, image, date, title, event, time, venue } = props;

  return (
    // Event item container
    <div className='event-item' key={id}>

      <div className='image'><img src={image} alt={title} /> </div> {/* Event image */}

      {/* Event content container */}
      <div className='content'>

        <div className="date"><span>{date.substring(0, 2)}</span> {date.substring(3, date.indexOf(','))}</div> {/* Displaying the day and month from the date string */}

        {/* Event details (time and venue) */}
        <div className='details'>
          <h3><FaClock className='icon' /><span>{time}</span></h3> {/* Event time */}
          <h3><FaMapMarkerAlt className='icon' /> <span>{venue}</span></h3> {/* Event venue */}
        </div>

        {/* Link to the individual event page */}
        <Link
          to={{
            pathname: '/Events/' + title, // Dynamic route based on event title
          }}
          state={event} // Passing the event data as state
          className='main-heading'>
          {title} {/* Event title */}
        </Link>

      </div>
    </div>
  );
};

export default Event;